'use strict';

$(document).ready(function(){

    const cardListNews = $('.cards__list--news');
    let offsetNews = 0

    //lazy loading для новостей
    function getNews() {
        offsetNews = offsetNews + 12
        $(window).on('scroll', function() {
            const lastElement = getLastChildElement('cards__item')

            if (isScrolledIntoView(lastElement)) {
                $(window).off('scroll');
                $.ajax({
                    type: "GET",
                    url: `/ajax/get-news?count=12&offset=${offsetNews}`,
                    success: function (data) {
                        getNews()
                        cardListNews[0].insertAdjacentHTML('beforeend', data);
                        clampText();
                    }
                });
            }
        });
    }

    if (location.href.indexOf('news') >= 0) {
        getNews();
    }

});
